import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { BASE_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';

const routes: LocalizedRoutes = {
  de: { path: BASE_PATH['de'] },
  en: { path: BASE_PATH['en'] },
  fr: { path: BASE_PATH['fr'] },
  it: { path: BASE_PATH['it'] },
};

const Component = () =>
  import(
    isPlatformIs24()
      ? '@/pages/LandingPage/LandingPageIs24.vue'
      : '@/pages/LandingPage/LandingPageHg.vue'
  );

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.LP);

export default localizedRouteConfig;
